import { createTheme } from "@mui/material";
import { COLORS } from "./constants/colors";

const theme = createTheme({
  palette: {
    primary: {
      main: COLORS.brand.primary,
    },
    success: {
      main: "#28a745",
    },
    error: {
      main: "#dc3545",
    },
    background: {
      default: "rgb(219, 226, 238)",
    },
    brand: {
      ticketHeader: COLORS.brand.ticketHeader,
    },
  },
  components: {
    MuiCssBaseline: {
      styleOverrides: {
        a: {
          color: "inherit",
          textDecoration: "none",
        },
      },
    },
    MuiFormControlLabel: {
      styleOverrides: {
        label: { color: COLORS.brand.primary },
      },
    },
  },
  typography: {
    h1: { color: COLORS.brand.primary },
    h2: { color: COLORS.brand.primary },
    h3: { color: COLORS.brand.primary },
    h4: { color: COLORS.brand.primary },
    h5: { color: COLORS.brand.primary },
    h6: { color: COLORS.brand.primary },
  },
});

export default theme;